// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vIsGV {\n  margin-right: var(--spacing-md);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textToSpeechWrapper": "vIsGV"
};
export default ___CSS_LOADER_EXPORT___;
